
import { type RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Research = lazy(() => import('../pages/research/page'));
const Members = lazy(() => import('../pages/members/page'));
const Achievements = lazy(() => import('../pages/achievements/page'));
const News = lazy(() => import('../pages/news/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Students = lazy(() => import('../pages/students/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/research',
    element: <Research />,
  },
  {
    path: '/members',
    element: <Members />,
  },
  {
    path: '/achievements',
    element: <Achievements />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/students',
    element: <Students />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
